import * as React from 'react';
import clsx from 'clsx';
import { Base } from '../../../components/Base';
import { ListContext } from '../context';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "root": "ListItem-root_YNj7Z",
  "bordered": "ListItem-bordered_30Zq2",
  "highlighted": "ListItem-highlighted_4CnOB",
  "highlighted-info": "ListItem-highlighted-info_BbqJK ListItem-highlighted_4CnOB",
  "highlighted-success": "ListItem-highlighted-success_3R_YZ ListItem-highlighted_4CnOB",
  "highlighted-warning": "ListItem-highlighted-warning_3GiTH ListItem-highlighted_4CnOB",
  "highlighted-danger": "ListItem-highlighted-danger_3qccQ ListItem-highlighted_4CnOB",
  "highlighted-placeholder": "ListItem-highlighted-placeholder_3Gm00 ListItem-highlighted_4CnOB"
};
function ListItem({
  children,
  className,
  highlight,
  ...extraProps
}) {
  const context = React.useContext(ListContext);
  const rootClasses = clsx(styles.root, {
    [styles[`highlighted-${highlight}`]]: highlight,
    [styles.bordered]: context.variant === 'bordered'
  }, className);
  return /*#__PURE__*/_jsx(Base, {
    className: rootClasses,
    ...extraProps,
    children: children
  });
}
export default ListItem;